import type { ShareContentType } from '../share-criteria-types.ts';

const DELIMITER = ',';

/**
 * Parses the raw `FLAG_TO_SHARE_CRITERIA_MET_TRIGGERED_TYPES` local storage
 * value (a delimited list of `ShareContentType`s) into a `Set`.
 */
function parseTriggeredTypes(rawValue: string | null | undefined): Set<string> {
	const triggeredTypes = new Set<string>();
	if (!rawValue) {
		return triggeredTypes;
	}

	const values = rawValue.split(DELIMITER);
	for (const value of values) {
		const trimmed = value.trim();
		if (trimmed) {
			triggeredTypes.add(trimmed);
		}
	}

	return triggeredTypes;
}

/**
 * Returns whether `type` is already present in the stored, delimited list of
 * content types that have previously fired the "criteria met" trigger.
 */
export function hasTypeTriggeredBefore(
	rawValue: string | null | undefined,
	type: ShareContentType,
): boolean {
	return parseTriggeredTypes(rawValue).has(type);
}

/**
 * Merges `type` into the stored, delimited list of previously-triggered
 * content types, returning the new value to persist. De-dupes and is a
 * no-op (returns the same content, re-joined) if `type` is already present.
 */
export function addTriggeredType(
	rawValue: string | null | undefined,
	type: ShareContentType,
): string {
	const triggeredTypes = parseTriggeredTypes(rawValue);
	triggeredTypes.add(type);
	return Array.from(triggeredTypes).join(DELIMITER);
}
